import {
  CalendarHolidays,
  Holiday,
  Id,
  Identifiable,
  Resource,
} from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

type HolidaysResponse = {
  _embedded?: {
    holidays: Identifiable<Holiday>[];
  };
};

function getHolidays(
  httpClient: HttpClient,
  calendarUuid: string,
): Promise<Identifiable<Holiday>[]> {
  return httpClient
    .sendHttpRequest<HolidaysResponse>({
      endpoint: `/calendarHolidayses/${calendarUuid}/holidays`,
      method: HttpMethods.GET,
    })
    .then((response) => response._embedded?.holidays || [])
    .catch((error) => {
      return Promise.reject({
        ...error,
        message: error.detail,
      });
    });
}

function getResourceCalendarHolidays(httpClient: HttpClient) {
  return (resource: Identifiable<Resource>) =>
    httpClient
      .sendHttpRequest<Identifiable<CalendarHolidays>>({
        endpoint: `/resources/${resource.uuid}/calendarHolidays`,
        method: HttpMethods.GET,
      })
      .then((calendarHolidays) => {
        if (calendarHolidays) {
          return getHolidays(httpClient, calendarHolidays.uuid).then(
            (holidays) => {
              return {
                ...calendarHolidays,
                holidays,
              };
            },
          );
        }
        return calendarHolidays;
      })
      .catch((error) => {
        return Promise.reject({
          ...error,
          message: error.detail,
        });
      });
}

export { getResourceCalendarHolidays };
